import React, { useEffect, useState } from 'react';
import styles from './GlobalPayModal.module.scss';
import Env from 'Env';
import Label from 'components/Common/Label';

const GlobalPayPayFieldsForm = (props) => {
  const {
    formLoading,
    setFormLoading,
    handlePayFieldInformationAccepted,
    handleCancel,
    displayAddress,
    addressLine1,
    setAddressLine1,
    addressLine2,
    setAddressLine2,
    addressCity,
    setAddressCity,
    addressState,
    setAddressState,
    addressZip,
    setAddressZip,
  } = props;

  const [cardError, setCardError] = useState(false);
  const [generalError, setGeneralError] = useState('');
  const [expError, setExpError] = useState(false);
  const [cvvError, setCvvError] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'globalpay-script';
    script.src =
      'https://js.paygateway.com/secure_payment/v1/globalpayments.js';
    script.async = true;
    document.body.appendChild(script);

    script.addEventListener('load', configurePayFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const configurePayFields = () => {
    window.GlobalPayments.configure({
      'X-GP-Api-Key': Env.globalPayPayFieldsKey,
      'X-GP-Environment': Env.globalPayEnvironment,
      enableAutocomplete: true,
    });

    var cardForm = window.GlobalPayments.ui.form({
      fields: {
        'card-number': {
          target: '#card-number',
          placeholder: '•••• •••• •••• ••••',
        },
        'card-expiration': {
          target: '#card-expiration',
          placeholder: 'MM / YYYY',
        },
        'card-cvv': {
          target: '#card-cvv',
          placeholder: '•••',
        },
        submit: {
          target: '#submit',
          text: 'Submit',
        },
      },

      styles: {
        input: {
          display: 'block',
          width: '100%',
          padding: '0.375rem 0.75rem',
          'font-size': '1rem',
          'font-weight': '400',
          'line-height': '1.5',
          color: '#495057',
          'background-color': '#fff',
          'background-clip': 'padding-box',
          border: '1px solid #ced4da',
          'border-radius': '0.25rem',
          transition:
            'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
          'font-family': 'Arial',
        },
        'button#secure-payment-field': {
          'background-color': '#124474',
          'border-color': '#124474',
          opacity: '1',
          'font-family': 'Arial',
          display: 'inline-block',
          'font-weight': '400',
          color: 'white',
          'text-align': 'center',
          'vertical-align': 'middle',
          'user-select': 'none',
          border: '1px solid transparent',
          padding: '.375rem .75rem',
          'font-size': '1rem',
          'line-height': '1.5',
          'border-radius': '.25rem',
          cursor: 'pointer',
        },
        'button#secure-payment-field:hover': {
          opacity: '0.8',
        },
      },
    });

    window.GlobalPayments.on('error', (error) => {
      console.error(error);
    });

    cardForm.on('token-success', (resp) => {
      handlePayFieldInformationAccepted(resp.temporary_token);
    });

    cardForm.on('token-error', (resp) => {
      console.log(resp);
      if (resp?.error) {
        const err = resp.error;
        if (err.code === 'invalid_card') {
          setCardError(true);
        } else if (err.code === 'invalid_input') {
          if (err.detail.some((det) => det.data_path === '/card/card-number')) {
            setCardError(true);
          }
          if (
            err.detail.some((det) => det.data_path === '/card/card-expiration')
          ) {
            setExpError(true);
          }
        } else {
          setGeneralError(resp?.error?.message);
        }
      }
    });

    cardForm.on('card-number-test', (resp) => {
      setCardError(!resp);
    });

    cardForm.on('card-expiration-test', (resp) => {
      setExpError(!resp);
    });

    cardForm.on('card-cvv-test', (resp) => {
      setCvvError(!resp);
    });

    setTimeout(() => setFormLoading(false), 1000);
  };

  // maybe fix the scrolling issues from the fields loading in
  return (
    <>
      <div
        style={{ opacity: formLoading ? 0 : 100 }}
        id='globalpay-payfields'
        className={styles.globalPayPayFieldsForm}
      >
        {generalError !== '' && (
          <span className={styles.globalPayPayFieldsError}>{generalError}</span>
        )}
        <div className='form-group'>
          <label for='card-number'>Card Number</label>
          <div id='card-number'></div>
          {cardError && (
            <span className={styles.globalPayPayFieldsError}>
              Card Number is Invalid
            </span>
          )}
        </div>
        <div className='form-group'>
          <label for='card-expiration'>Expiration</label>
          <div id='card-expiration'></div>
          {expError && (
            <span className={styles.globalPayPayFieldsError}>
              Expiration is Invalid
            </span>
          )}
        </div>
        <div className='form-group'>
          <label for='card-cvv'>CVV</label>
          <div id='card-cvv'></div>
          {cvvError && (
            <span className={styles.globalPayPayFieldsError}>
              CVV is Invalid
            </span>
          )}
        </div>
        {displayAddress && (
          <div className={styles.globalPayAddressForm}>
            <div>
              <Label text='Billing Address' hasError={addressLine1 === ''} />
              <div className={styles.spaceChildrenEvenly}>
                <input
                  type='text'
                  className={styles.globalPayPayField}
                  placeholder='Address Line 1'
                  autocomplete='disabled'
                  value={addressLine1}
                  onChange={(e) => setAddressLine1(e.currentTarget.value)}
                />
                <input
                  type='text'
                  className={styles.globalPayPayField}
                  placeholder='Address Line 2'
                  autocomplete='disabled'
                  value={addressLine2}
                  onChange={(e) => setAddressLine2(e.currentTarget.value)}
                />
              </div>
            </div>

            <div className={styles.globalPayPartialAddressInput}>
              <div>
                <Label text='City' hasError={addressCity === ''} />
                <input
                  className={styles.globalPayPayField}
                  type='text'
                  placeholder='City'
                  autocomplete='disabled'
                  value={addressCity}
                  onChange={(e) => setAddressCity(e.currentTarget.value)}
                />
              </div>

              <div>
                <Label text='State' hasError={addressState === ''} />
                <input
                  className={styles.globalPayPayField}
                  type='text'
                  placeholder='State'
                  autocomplete='disabled'
                  value={addressState}
                  onChange={(e) => setAddressState(e.currentTarget.value)}
                />
              </div>

              <div>
                <Label text='Zip' hasError={addressZip === ''} />
                <input
                  className={styles.globalPayPayField}
                  type='text'
                  placeholder='Zip'
                  autocomplete='disabled'
                  value={addressZip}
                  onChange={(e) => setAddressZip(e.currentTarget.value)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={styles.globalPayPayFieldSubmit}>
        <button type='button' class='btn btn-light' onClick={handleCancel}>
          Cancel
        </button>
        <div
          id='submit'
          style={
            addressLine1 === '' || addressZip === ''
              ? {
                  pointerEvents: 'none',
                  userSelect: 'none',
                  cursor: 'not-allowed',
                  opacity: '0.8',
                }
              : {}
          }
        ></div>
      </div>
    </>
  );
};

export default GlobalPayPayFieldsForm;
